<template>
  <div>
    <div class="check_main">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" width="80" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称">
        </el-table-column>
        <el-table-column
          prop="isFirstInventoryCheck"
          align="center"
          label="是否初次盘点"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.isFirstInventoryCheck == 1 ? "是" : "否" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <div>
              <span class="operation_btn" @click="customerEdit(scope.row)"
                >编辑</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="check_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[20, 30, 50, 100, 200, 500]"
        :page-size="pageSize"
        layout="total,sizes, prev, pager, next"
        :total="total"
        :background="true"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import editVue from "./edit.vue";
export default {
  components: {
    editVue,
  },
  data() {
    return {
      tableData: [],
      currentPage2: 1,
      total: 0,
      pageSize: 20,
      //   isFirstInventoryCheck: "",
      options: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let d = {};
      d.pageSize = this.pageSize;
      d.pageNum = this.currentPage2;
      let res = await $utils.api.load(
        "admin/system/customer/listByInventoryMark",
        d,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        this.total = res.total;
        this.tableData = res.rows;
      }
    },
    customerEdit(row) {
      console.log(row);
      this.$Modal.success({
        title: "盘点",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return <editVue row={row} onFirstCheckModal={this.firstCheckModal} />;
        },
      });
    },
    firstCheckModal() {
      this.$Modal.remove();
      this.load();
    },
    onChangeSelect(e) {
      console.log(e);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.currentPage2 = 1;
      this.load();
    },
    handleCurrentChange(val) {
      this.currentPage2 = val;
      this.load();
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff !important;
}
.check_footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.operation_btn {
  display: inline-block;
  color: #2d8cf0;
  cursor: pointer;
}
</style>